import React, { useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { AdminHeader } from '../';
import { Title } from '../../Shared';
import { contentActions } from '../../_actions';

function ViewContentSingle(props) {
  const { getContent, bySlug } = props;
  const { section } = props.match.params;

  useEffect(() => {
    getContent(section);
  }, [getContent, section]);

  const content = bySlug[section];

  return (
    <Fragment>
      {content && (
        <Fragment>
          <Title text={content.section.name} />
          <AdminHeader goBack title={`${content.section.name} Content`} />
          <Container className="mt-4">
            <Row>
              <Col>
                <h4>{content.title}</h4>
                <div dangerouslySetInnerHTML={{ __html: content.copy }} />
              </Col>
            </Row>
          </Container>
        </Fragment>
      )}
      {!content && <NoContent />}
    </Fragment>
  );
}
function NoContent() {
  return (
    <Fragment>
      <Title text="Not Found" />
      <AdminHeader goBack title="No Content Found" />
      <Container className="mt-4">
        <Row>
          <Col>
            <p>No content exists for this section.</p>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

const mapDispatch = {
  getContent: contentActions.bySectionSlug
};

function mapState(state) {
  const { bySlug } = state.content;
  return { bySlug };
}

const connectedViewContentSingle = connect(
  mapState,
  mapDispatch
)(ViewContentSingle);
export { connectedViewContentSingle as ViewContentSingle };
